import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { BodyConfig, TypographyConfig, Body } from '@vds-core/typography';
import { colors, calculateSpacing } from '@vds-core/theme';
var propTypes = {
  /**
   *  sets Max character length for input field
   */
  maxLength: PropTypes.number,

  /**
   * @ignore config for passing though typography
   */
  bodyConfig: PropTypes.object,

  /**
   * If provided, the Input will be rendered in the Disabled State.
   */
  disabled: PropTypes.bool,

  /**
   * @ignore - passes through typescale via sting if there's more than one option [example 'VDS' instead of 'MVP']
   */
  typescale: PropTypes.string,

  /**
   * @ignore If passed, new Body component will render
   */
  Body: PropTypes.func,

  /**
   * @ignore - config for passing through other colors
   */
  color: PropTypes.object,

  /**
   * value of input
   */
  value: PropTypes.string
};
var defaultProps = {
  disabled: false,
  typescale: TypographyConfig.getTypescale(),
  bodyConfig: BodyConfig,
  Body: Body,
  color: colors
};
var CounterWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "CounterWrapper",
  componentId: "p5m1xl-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", " 0 0 ", ";\n"])), calculateSpacing('2X'), calculateSpacing('3X'));

var CharacterCounter = function CharacterCounter(_ref) {
  var maxLength = _ref.maxLength,
      disabled = _ref.disabled,
      bodyConfig = _ref.bodyConfig,
      typescale = _ref.typescale,
      Body = _ref.Body,
      color = _ref.color,
      value = _ref.value;
  var valueLength = value.length;
  return /*#__PURE__*/React.createElement(CounterWrapper, null, /*#__PURE__*/React.createElement(Body, {
    config: bodyConfig,
    color: disabled ? color.coolGray3 : color.black,
    typescale: typescale,
    tabIndex: -1
  }, valueLength <= maxLength ? "".concat(valueLength, "/").concat(maxLength) : "".concat(maxLength - valueLength)));
};

CharacterCounter.propTypes = propTypes;
CharacterCounter.defaultProps = defaultProps;
export default CharacterCounter;